export default __webpack_public_path__ + "images/2b958638958317bde9ac7fbe5f43cd7d.webp";